import PERMISSIONS from '../enum';
const userAccess = {
  create: [PERMISSIONS.USER.WRITE],
  edit: [PERMISSIONS.USER.WRITE],
  activate: [PERMISSIONS.USER.ACTIVATE],
  delete: [PERMISSIONS.USER.DELETE],
  view: [PERMISSIONS.USER.VIEW],
};
export default userAccess;
